<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Información de la Marca"
          :datos="marcaDatos">
        </app-data>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos de la Marca</b-dropdown-item>
          <b-dropdown-item @click.stop="goList">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'marca/getField',
  mutationType: 'marca/updateField',
});

export default {
  name: 'MarcaDatos',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      marcaId: 0,
    }
  },
  computed: {
    ...mapFields([
      'marcaDatos',
    ]),
  },  
  created() {
    this.marcaId= this.$route.params.id

    this.$store.dispatch('marca/getDatos', this.marcaId)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goList() {
      this.$router.push({ name: 'Marcas' }); 
    },
    editar() {
      this.$router.push({ name: 'MarcaEdit', 
                          params: { id: this.marcaId }})
    },
  }
}
</script>
